import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {
  ServiceEventTypeServiceType,
  ServiceEventTypeServiceTypeEntity
} from "../../../model/service/service-event-type-service-type";

export interface ServiceEventTypeServiceTypeSelectorProps {

}

export const serviceEventTypeServiceTypesSelector = () => createSelector(
  [getUseQueryResultData<ServiceEventTypeServiceType[]>],
  (data) => {
    return selectServiceEventTypeServiceTypesAndTransform(
      data ?? [], {}
    );
  }
);

export const serviceEventTypeServiceTypeSelector = () => createSelector(
  [getUseQueryResultData<ServiceEventTypeServiceType>],
  (data) => {
    return data ? transformServiceEventTypeServiceType(data) : undefined;
  }
);

export const selectServiceEventTypeServiceTypes = (values?: ServiceEventTypeServiceType[], selector?: ServiceEventTypeServiceTypeSelectorProps): ServiceEventTypeServiceType[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    return filterIn;
  });
};

export const transformServiceEventTypeServiceType = (value: ServiceEventTypeServiceType): ServiceEventTypeServiceTypeEntity => {
  return ServiceEventTypeServiceTypeEntity.from(value)
}

export const selectServiceEventTypeServiceTypesAndTransform = (values?: ServiceEventTypeServiceType[], selector?: ServiceEventTypeServiceTypeSelectorProps): ServiceEventTypeServiceTypeEntity[] => {
  const selected = selectServiceEventTypeServiceTypes(values, selector);
  return selected.map(transformServiceEventTypeServiceType);
};
